import { collectedDataStatusTitle, collectedDataStepsTitle } from 'src/constants/collectedData'
import { failureReasonTitles } from 'src/constants/payment/constants'
import {
  CollectDataStepContractorActivitiesLog,
  CollectDataStepUpdatedContractorActivitiesLog,
  ContractorActivitiesLog,
  PaymentFailedContractorActivitiesLog,
} from 'src/interfaces/contractor'
import { replaceTrainingWording } from 'src/utils/certificationWording'

const collectedDataStepActivityLogsTypes = [
  'collect_data_step_started',
  'collect_data_step_submitted',
  'collect_data_step_auto_approved',
  'collect_data_step_approved',
  'collect_data_step_declined',
  'collect_data_step_failed',
  'collect_data_step_internally_approved',
]

const activityLogIsCollectDataStep = (
  activityLog: ContractorActivitiesLog,
): activityLog is CollectDataStepContractorActivitiesLog =>
  collectedDataStepActivityLogsTypes.includes(activityLog.type)

const activityLogIsCollectDataStepUpdated = (
  activityLog: ContractorActivitiesLog,
): activityLog is CollectDataStepUpdatedContractorActivitiesLog =>
  activityLog.type === 'collect_data_step_updated'

const activityLogIsPaymentFailed = (
  activityLog: ContractorActivitiesLog,
): activityLog is PaymentFailedContractorActivitiesLog => activityLog.type === 'payment_failed'

export const formatActivityLogMessage = (activityLog: ContractorActivitiesLog): string => {
  if (activityLogIsPaymentFailed(activityLog)) {
    return activityLog.description.replace(
      activityLog.metadata.failureReasonType,
      `"${
        failureReasonTitles[activityLog.metadata.failureReasonType] ||
        activityLog.metadata.failureReasonType
      }"`,
    )
  }

  if (activityLogIsCollectDataStep(activityLog)) {
    let stepName =
      collectedDataStepsTitle[activityLog.metadata.collectDataStepLabel] ||
      activityLog.metadata.collectDataStepLabel

    if (activityLog.metadata.insuranceProductName) {
      stepName = `Insurance Coverage - ${activityLog.metadata.insuranceProductName}`
    }

    if (
      activityLog.metadata.lmsTrainingName &&
      activityLog.metadata.collectDataStepType === 'lms_training'
    ) {
      stepName = `Certification Step - ${activityLog.metadata.lmsTrainingName}`
    }

    return activityLog.description.replace(activityLog.metadata.collectDataStepLabel, () => {
      return `"${replaceTrainingWording(stepName)}"`
    })
  }

  if (activityLogIsCollectDataStepUpdated(activityLog)) {
    return activityLog.description
      .replace(
        activityLog.metadata.collectDataStepLabel,
        `"${replaceTrainingWording(
          collectedDataStepsTitle[activityLog.metadata.collectDataStepLabel] ||
            activityLog.metadata.collectDataStepLabel,
        )}"`,
      )
      .replace(
        activityLog.metadata.newStatus,
        `"${
          collectedDataStatusTitle[activityLog.metadata.newStatus] || activityLog.metadata.newStatus
        }"`,
      )
  }

  return activityLog.description
}
